import { Breadcrumb, Button, Form, Input, Table } from "antd";
import { ExportOutlined, HomeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Excel } from "antd-table-saveas-excel";
import { _adr } from "../../../../address";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";
import { convertToJalaliWithoutTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";
import styles from "./dealerKitInventory.module.scss";

const cTable = [
	{ title: "کیت", dataIndex: "kitNo", key: "kitNo", width: 150 },
	{ title: "تاریخ تخصیص", dataIndex: "transferDate", key: "transferDate", width: 150 },
];

const DistributorKitInventory = () => {
	const [frmSearch] = Form.useForm();

	const { queryMyKits } = useDealer();

	const [isLoading, setIsLoading] = useState(false);

	// state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const [dataSource, setDataSource] = useState([]);

	const handleSearch = async () => {
		setIsLoading(true);
		try {
			const values = frmSearch.getFieldsValue();
			const payload = {
				searchConfigModel: {
					sort: "",
					filter: values?.iccid || "",
					entriesPerPage: 10,
					page: currentPage === 0 ? 0 : currentPage - 1,
					totalRowCount: 1,
				},
				freeKits: false,
			};

			const response = await queryMyKits(payload);
			if (response) {
				setDataSource(
					(response?.Result || []).map((item, key) => ({
						key,
						kitNo: item.inT_KitNo,
						transferDate: convertToJalaliWithoutTime(item.dtE_TransferDate),
					})),
				);
				setTotalRecord(response?.searchconfigmodel?.totalrowcount || 0);
			}
		} catch (error) {
			console.error("Failed to load distributor free kits:", error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		handleSearch();
	}, [currentPage]);

	const handleExport = () => {
		const excel = new Excel();
		excel
			.addSheet("موجودی کیت توزیع کننده")
			.addColumns(cTable)
			.addDataSource(dataSource, { str2Percent: true })
			.saveAs("distributor-kit-inventory.xlsx");
	};

	return (
		<div className="container-main container-cw">
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[
							{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest, title: "مدیریت کیت سیم‌کارت" },
							{ title: "موجودی کیت توزیع کننده" },
						]}
					/>
					<div className="title-page">
						<h3>موجودی کیت توزیع کننده</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className={`g-body-format-page ${styles.container}`}>
							<div className="holder-table">
								<div className="holder-top-table">
									<div className="holder-search">
										<Form form={frmSearch} onFinish={handleSearch} layout="inline">
											<Form.Item name="iccid" className="input-normal">
												<Input placeholder="شماره کیت" allowClear />
											</Form.Item>
											<Form.Item>
												<Button htmlType="submit" className="btn-normal btn-aptel" icon={<SearchOutlined />} />
											</Form.Item>
										</Form>
									</div>
									<div className="holder-button">
										<Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
											خروجی اکسل
										</Button>
									</div>
								</div>
								<Table
									className="tbl-normal"
									columns={cTable}
									locale={{
										emptyText: <NotFound text={"رکوردی یافت نشد."} />,
									}}
									pagination={{
										className: "page-pagination",
										onChange: (page) => {
											setCurrentPage(page);
										},
										pageSize: 10,
										align: "start",
										current: currentPage === 0 ? 1 : currentPage,
										total: totalRecord,
										showSizeChanger: false,
									}}
									scroll={{ y: "100%" }}
									dataSource={dataSource}
								/>
							</div>
						</div>
					</div>
				</Content>
				<Loading isOpen={isLoading} />
			</div>
		</div>
	);
};

export default DistributorKitInventory;
